export default __webpack_public_path__ + "static/media/appPagoPorAssinatura.cd650bcf.svg";